// extracted by css-extract-rspack-plugin
export default {"heading":"TaskSwitcher-module__heading__mglHl","taskSwitcherButton":"TaskSwitcher-module__taskSwitcherButton__vPHEz"};